import React from "react";
import KnowledgePage from "../../components/knowledge/KnowledgePage/KnowledgePage";

/**
 * Trang mẹo làm bài TOEIC, dùng chung KnowledgePage với mode tips.
 */
function TipsPage() {
  return <KnowledgePage kind="tips" />;
}

export default TipsPage;
